import {SLUGS} from '@px/const/slugs';
import {appendTemplates} from '@px/helper/template';

export const templates: Template[] = [
  {
    slug: SLUGS.BUY_CRYPTO_BUY_ALGO,
    loader: () => import('px-home/src/modules/buy-crypto/buy-algo'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_AVAX,
    loader: () => import('px-home/src/modules/buy-crypto/buy-avax'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_BTC,
    loader: () => import('px-home/src/modules/buy-crypto/buy-btc'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_BCH,
    loader: () => import('px-home/src/modules/buy-crypto/buy-bch'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_ADA,
    loader: () => import('px-home/src/modules/buy-crypto/buy-ada'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_MANA,
    loader: () => import('px-home/src/modules/buy-crypto/buy-mana'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_DENT,
    loader: () => import('px-home/src/modules/buy-crypto/buy-dent'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_DOGE,
    loader: () => import('px-home/src/modules/buy-crypto/buy-doge'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_ETHEREUM,
    loader: () => import('px-home/src/modules/buy-crypto/buy-ethereum'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_LTC,
    loader: () => import('px-home/src/modules/buy-crypto/buy-ltc'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_LRC,
    loader: () => import('px-home/src/modules/buy-crypto/buy-lrc'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_MATIC,
    loader: () => import('px-home/src/modules/buy-crypto/buy-matic'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_DOT,
    loader: () => import('px-home/src/modules/buy-crypto/buy-dot'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_SAND,
    loader: () => import('px-home/src/modules/buy-crypto/buy-sand'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_SHIB,
    loader: () => import('px-home/src/modules/buy-crypto/buy-shib'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_SOL,
    loader: () => import('px-home/src/modules/buy-crypto/buy-sol'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_XTZ,
    loader: () => import('px-home/src/modules/buy-crypto/buy-xtz'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_TRX,
    loader: () => import('px-home/src/modules/buy-crypto/buy-trx'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_USDC,
    loader: () => import('px-home/src/modules/buy-crypto/buy-usdc'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_XLM,
    loader: () => import('px-home/src/modules/buy-crypto/buy-xml'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_XRP,
    loader: () => import('px-home/src/modules/buy-crypto/buy-xrp'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_BUY_ZEC,
    loader: () => import('px-home/src/modules/buy-crypto/buy-zec'),
  },
  {
    slug: SLUGS.BUY_CRYPTO,
    loader: () => import('px-home/src/modules/buy-crypto'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_FAQ,
    loader: () => import('px-home/src/modules/buy-crypto/faq'),
  },
  {
    slug: SLUGS.P2P_HOME,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/place-order/home'),
  },
  {
    slug: SLUGS.P2P_MAKER_HOME,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/advertiser'),
  },
  {
    slug: SLUGS.P2P_ADVERTISER_REVIEW,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/advertiser/leave-a-review'),
  },
  {
    slug: SLUGS.P2P_CREATE_AN_AD,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/create-an-ad'),
  },
  {
    slug: SLUGS.P2P_FAQ,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/faq'),
  },
  {
    slug: SLUGS.P2P_MY_ADS,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/my-ads/home'),
  },
  {
    slug: SLUGS.P2P_ADS_DETAILS,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/my-ads/details'),
  },
  {
    slug: SLUGS.P2P_ADS_EDIT,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/my-ads/edit'),
  },
  {
    slug: SLUGS.P2P_ORDERS,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/orders'),
  },
  {
    slug: SLUGS.P2P_HOME_MARKET,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/markets'),
  },
  {
    slug: SLUGS.P2P_MERCHANT_APPLY,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/p2p-merchant-apply'),
  },
  {
    slug: SLUGS.ASSETS_PAYMENT_METHODS,
    loader: () => import('px-home/src/modules/account/fiat-payment-methods'),
  },
  {
    slug: SLUGS.P2P_HOME_LOGIN,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/place-order'),
  },
  {
    slug: SLUGS.P2P_ORDER_DETAILS,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/place-order/details'),
  },
  {
    slug: SLUGS.P2P_APPEAL_AN_ORDER,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/place-order/appeal-an-order'),
  },
  {
    slug: SLUGS.P2P_USER_CENTER,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/user-center'),
  },
  {
    slug: SLUGS.P2P_USER_REVIEW,
    loader: () => import('px-home/src/modules/buy-crypto/fiat/advertiser/leave-a-review'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_HOW_TO_BUY,
    loader: () => import('px-home/src/modules/buy-crypto/how-to-buy-bitcoin'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_PLACE_ORDER,
    loader: () => import('px-home/src/modules/buy-crypto/place-order'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_PLACE_ORDER_HISTORY,
    loader: () => import('px-home/src/modules/buy-crypto/place-order/history'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_HISTORY,
    loader: () => import('px-home/src/modules/buy-crypto/card/history'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_ORDER_CONFIRM,
    loader: () => import('px-home/src/modules/fiat/credit-debit-card/confirm-buy'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_ORDER_FAIL,
    loader: () => import('px-home/src/modules/buy-crypto/card/order-fail'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_ORDER_SUCCESS,
    loader: () => import('px-home/src/modules/buy-crypto/card/order-success'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_PAY,
    loader: () => import('px-home/src/modules/fiat/mercuryo-payment'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_PAYMENT,
    loader: () => import('px-home/src/modules/buy-crypto/card/payment'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_PLACE_ORDER,
    loader: () => import('px-home/src/modules/fiat/credit-debit-card/place-order'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_DETAILS,
    loader: () => import('px-home/src/modules/buy-crypto/card/card-details'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_SELL_CONFIRM,
    loader: () => import('px-home/src/modules/fiat/credit-debit-card/confirm-sell'),
  },
  {
    slug: SLUGS.BUY_CRYPTO_CARD_SELL_RESULT,
    loader: () => import('px-home/src/modules/buy-crypto/card/sell-result'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_BUY_CARD,
    loader: () => import('px-home/src/modules/fiat/buy-crypto/buy/card'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_BUY_CONFIRM,
    loader: () => import('px-home/src/modules/fiat/one-click-transaction/confirm-buy'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_BUY_PAYMENT_METHOD,
    loader: () => import('px-home/src/modules/fiat/one-click-transaction/select-payment-buy'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_BUY_TRANSAK,
    loader: () => import('px-home/src/modules/fiat/transak-payment'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_BUY_TRANSAK_RESULT,
    loader: () => import('px-home/src/modules/fiat/buy-crypto/buy/transak/result'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_BUY_RESULT,
    loader: () => import('px-home/src/modules/fiat/buy-crypto/buy/result'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_PLACE_ORDER,
    loader: () => import('px-home/src/modules/fiat/one-click-transaction/place-order'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_SELL_CARD,
    loader: () => import('px-home/src/modules/fiat/buy-crypto/sell/card'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_SELL_CONFIRM,
    loader: () => import('px-home/src/modules/fiat/one-click-transaction/confirm-sell'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_SELL_PAYMENT_METHOD,
    loader: () => import('px-home/src/modules/fiat/one-click-transaction/select-payment-sell'),
  },
  {
    slug: SLUGS.FIAT_BUY_CRYPTO_SELL_RESULT,
    loader: () => import('px-home/src/modules/fiat/buy-crypto/sell/result'),
  },
  {
    slug: SLUGS.FIAT_DEPOSIT,
    loader: () => import('px-home/src/modules/fiat/deposit-withdraw-transaction/place-order'),
  },
  {
    slug: SLUGS.FIAT_WITHDRAW,
    loader: () => import('px-home/src/modules/fiat/withdraw/place-order'),
  },
  {
    slug: SLUGS.FIAT_WITHDRAW_ORDER_CONFIRM,
    loader: () => import('px-home/src/modules/fiat/deposit-withdraw-transaction/withdraw-confirm-order'),
  },
  {
    slug: SLUGS.FIAT_DEPOSIT_TRANSFER_INFO,
    loader: () => import('px-home/src/modules/fiat/deposit-withdraw-transaction/deposit-transfer-info'),
  },
  {
    slug: SLUGS.FIAT_WITHDRAW_ORDER_RESULT,
    loader: () => import('px-home/src/modules/fiat/withdraw/order-result'),
  },
  {
    slug: SLUGS.FIAT_B2C_URL_PAYMENT,
    loader: () => import('px-home/src/modules/fiat/b2c-url-payment'),
  },
  {
    slug: SLUGS.FIAT_B2C_PAYMENT_RESULT,
    loader: () => import('px-home/src/modules/fiat/b2c-url-payment/b2c-payment-result'),
  },
];

appendTemplates(templates);
